<template>
  <div aria-hidden="true" class="relative">
    <div
      class="border-t-static-default-low rounded-xs absolute bottom-0 h-3 w-full border-t-3"
    >
      <div
        class="border-t-static-default-hi rounded-sm absolute -top-3 border-t-3 ease-in-out motion-safe:transition-all motion-safe:duration-200"
        :style="progressStyle"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{ currentValue?: number; max?: number }>(),
  { currentValue: 0, max: 100 },
)

const progressStyle = computed(() => ({
  width: `${
    100 * Math.max(Math.min(props.currentValue, props.max) / props.max, 0)
  }%`,
}))
</script>
